module.exports = __webpack_public_path__ + "static/media/Winchester-2.a3342ec7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-la/Winchester-2.jpg
// module id = 431
// module chunks = 0